import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_ALL_SCHEMES,
  getAllSchemesSuccess,
  getAllSchemesFailure,
  ADD_SCHEME,
  addSchemeFailure,
  addSchemeSuccess,
  DELETE_SCHEME,
  deleteSchemeFailure,
  deleteSchemeSuccess,
  UPDATE_SCHEME,
  updateSchemeFailure,
  updateSchemeSuccess,
  UPDATE_SCHEME_STATUS,
  updateSchemeStatusFailure,
  updateSchemeStatusSuccess,
  CLEAR_ADD_SCHEME,
  clearAddScheme,
  GET_USER_SCHEME,
  getUserSchemesSuccess,
  getUserSchemesFailure,
  GET_SCHEMES_BY_ID,
  getSchemesByIdFailure,
  getSchemesByIdSuccess,
  SYNC_UPLOAD,
  syncUploadFailure,
  syncUploadSuccess,
  getAllNewSchemesSuccess,
  getAllNewSchemesFailure,
  GET_ALL_NEW_SCHEMES,
  getNewSchemesByIdSuccess,
  getNewSchemesByIdFailure,
  GET_NEW_SCHEMES_BY_ID,
  ADD_UPDATE_NEW_SCHEME,
  SEND_TEST_NOTIFICATION,
  GET_DEEP_LINKS,
  getAllDeepLinksSuccess,
  getAllDeepLinksFailure,
  GET_ALL_APP_IDS,
  getAllAppIdsSuccess,
  getAllAppIdsFailure,
} from "../actions/scheme-action-types";
import { showLoader, hideLoader } from "../actions/app-action-types";
import {
  AddScheme,
  DeleteScheme,
  UpdateScheme,
  UpdateSchemeStatus,
  GetUserScheme,
  GetSchemeList,
  GetSchemeById,
  SyncUpload,
  GetNewSchemeList,
  GetNewSchemeById,
  AddUpdateNewScheme,
  SendTestNotification,
  GetDeepLinks,
  GetAllAppIds,
} from "../api";

// Get All Schemes.
function* getSchemes(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetSchemeList(val?.payload));
    yield put(getAllSchemesSuccess(result.data));
  } catch (error) {
    yield put(getAllSchemesFailure({ error }));
  }
  yield put(hideLoader());
}

// Get Schemes by Id.
function* getSchemeById(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetSchemeById(val?.payload));
    yield put(getSchemesByIdSuccess(result.data));
  } catch (error) {
    yield put(getSchemesByIdFailure({ error }));
  }
  yield put(hideLoader());
}

function* addScheme(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => AddScheme(val.payload));
    yield put(addSchemeSuccess(result));
  } catch (error) {
    yield put(addSchemeFailure({ error }));
  }
  yield put(hideLoader());
}

function* deleteScheme(val) {
  yield put(showLoader());
  try {
    yield call(() => DeleteScheme(val.payload));
    yield put(deleteSchemeSuccess(val.payload));
  } catch (error) {
    yield put(deleteSchemeFailure({ error }));
  }
  yield put(hideLoader());
}

function* updateSchemeStatus(val) {
  yield put(showLoader());
  try {
    yield call(() => UpdateSchemeStatus(val.payload.docId, val.payload.status));
    yield put(
      updateSchemeStatusSuccess({
        docId: val.payload.docId,
        status: val.payload.status,
      })
    );
  } catch (error) {
    yield put(updateSchemeStatusFailure({ error }));
  }
  yield put(hideLoader());
}

function* updateScheme(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => UpdateScheme(val.payload));
    yield put(updateSchemeSuccess(result));
  } catch (error) {
    yield put(updateSchemeFailure({ error }));
  }
  yield put(hideLoader());
}

// Get User Schemes.
function* getUserSchemes(val) {
  yield put(showLoader());
  try {
    const result = yield call(() =>
      GetUserScheme(
        val.payload.customerId,
        val.payload.appId,
        val.payload.token
      )
    );
    yield put(getUserSchemesSuccess(result.data));
  } catch (error) {
    yield put(getUserSchemesFailure({ error }));
  }
  yield put(hideLoader());
}

// Sync Upload
function* syncUpload() {
  yield put(showLoader());
  try {
    const result = yield call(SyncUpload);
    yield put(syncUploadSuccess(result.data));
  } catch (error) {
    yield put(syncUploadFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All New Schemes.
function* getNewSchemes(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetNewSchemeList(val?.payload));
    yield put(getAllNewSchemesSuccess(result.data));
  } catch (error) {
    yield put(getAllNewSchemesFailure({ error }));
  }
  yield put(hideLoader());
}

// Get New Schemes by Id.
function* getNewSchemeById(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetNewSchemeById(val?.payload));
    yield put(getNewSchemesByIdSuccess(result.data));
  } catch (error) {
    yield put(getNewSchemesByIdFailure({ error }));
  }
  yield put(hideLoader());
}

function* addUpdateNewScheme(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => AddUpdateNewScheme(val.payload.params));
    yield put(addSchemeSuccess(result));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    yield put(addSchemeFailure({ error }));
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

function* sendTestNotification(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => SendTestNotification(val.payload.params));
    if (val.payload?.onSuccess) val.payload?.onSuccess(result);
  } catch (error) {
    if (val.payload?.onError) val.payload?.onError({ error });
  }
  yield put(hideLoader());
}

// Get All Deep Links
function* getAllDeepLinks(val) {
  yield put(showLoader());
  try {
    const result = yield call(() => GetDeepLinks(val?.payload));
    yield put(getAllDeepLinksSuccess(result.data));
  } catch (error) {
    yield put(getAllDeepLinksFailure({ error }));
  }
  yield put(hideLoader());
}

// Get All App Ids
function* getAllAppIds() {
  yield put(showLoader());
  try {
    const result = yield call(() => GetAllAppIds());
    yield put(getAllAppIdsSuccess(result.data));
  } catch (error) {
    yield put(getAllAppIdsFailure({ error }));
  }
  yield put(hideLoader());
}

// Combine all schemes action into one saga function.
function* Schemes() {
  yield all([
    takeLatest(GET_ALL_SCHEMES, getSchemes),
    takeLatest(ADD_SCHEME, addScheme),
    takeLatest(DELETE_SCHEME, deleteScheme),
    takeLatest(UPDATE_SCHEME_STATUS, updateSchemeStatus),
    takeLatest(UPDATE_SCHEME, updateScheme),
    takeLatest(CLEAR_ADD_SCHEME, clearAddScheme),
    takeLatest(GET_USER_SCHEME, getUserSchemes),
    takeLatest(GET_SCHEMES_BY_ID, getSchemeById),
    takeLatest(SYNC_UPLOAD, syncUpload),
    takeLatest(GET_ALL_NEW_SCHEMES, getNewSchemes), // To Get Announcement and Notifications List
    takeLatest(GET_NEW_SCHEMES_BY_ID, getNewSchemeById),
    takeLatest(ADD_UPDATE_NEW_SCHEME, addUpdateNewScheme), // To add/Update Announcement and Notifications
    takeLatest(SEND_TEST_NOTIFICATION, sendTestNotification),
    takeLatest(GET_DEEP_LINKS, getAllDeepLinks),
    takeLatest(GET_ALL_APP_IDS, getAllAppIds),
  ]);
}

export default Schemes;
